import React from "react";
import { ArrowRightIcon } from "lucide-react";
import type { CaseStudyContent } from "../../data/caseStudies";
import { CaseStudySection } from "./CaseStudySection";
import { BODY, H3 } from "../../utils/typography";
type ProcessSectionProps = {
  process: CaseStudyContent["process"];
};
export function ProcessSection({
  process
}: ProcessSectionProps) {
  return <CaseStudySection label="The Process" data-id="element-74" data-mp="1w3mrb95sg52n">
      <ol className="grid grid-cols-1 gap-x-10 gap-y-10 md:grid-cols-2" data-id="element-75" data-mp="1w2lgn5sopklg">
        {process.steps.map((step, i) => <li key={step.title} data-id="element-76" data-mp="1s1hygcn5zch2" data-mpi={i}>
            <p className="text-sm text-espresso/70" data-id="element-77" data-mp="1s4e1gfdvcrcd">
              {String(i + 1).padStart(2, "0")} <span aria-hidden="true" data-id="element-78" data-mp="25zq213ephc17">/</span>
            </p>
            <h3 className={`mt-2 ${H3} text-espresso`} data-id="element-79" data-mp="213r70wyvgvrt">{step.title}</h3>
            <p className={`mt-3 ${BODY} text-espresso/70`} data-id="element-80" data-mp="bn9odhjkyvmb">{step.body}</p>
          </li>)}
      </ol>

      {process.flow && <ol aria-label="Journey" className="mt-12 flex flex-wrap items-center gap-x-2 gap-y-3" data-id="element-81" data-mp="6q00457xgq02">
          {process.flow.map((stage, i) => <li key={stage} className="flex items-center gap-2" data-id="element-82" data-mp="265nrbfe7ob7a" data-mpi={i}>
              <span className="whitespace-nowrap rounded-full bg-paper px-4 py-2 text-sm font-medium text-espresso" data-id="element-83" data-mp="265w4l8e8xij0">
                {stage}
              </span>
              {i < process.flow!.length - 1 && <ArrowRightIcon className="h-4 w-4 text-espresso/40" aria-hidden="true" data-id="element-84" data-mp="2f02hwe46z85p" />}
            </li>)}
        </ol>}

      {process.closing && <p className={`mt-12 max-w-2xl ${H3} text-espresso`} data-id="element-85" data-mp="2oukp3t8thlu9">
          {process.closing}
        </p>}
    </CaseStudySection>;
}